import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-firsttimebuyer',
  templateUrl: './firsttimebuyer.component.html',
  styleUrls: ['./firsttimebuyer.component.css']
})
export class FirsttimebuyerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
